<template>
    <div class="border border-red-500 bg-red-100 p-4 text-red-800">
        <div class="font-bold">{{ title }}</div>
        <div class="mt-2">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
    }
}
</script>